import * as swcHelpers from '@swc/helpers';
import { LineItemType, BundleLineItemType } from '../../../__generated__/sharedTypes.js';

const mapNonPrescriptionBundleLineItem = ({ sku , quantity , bundleLineItems  })=>{
    const mainBundleLineItem = {
        sku,
        quantity: 1,
        isMainBundleLineItem: true
    };
    var _quantity;
    return {
        sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.BUNDLE,
        bundleLineItemsType: BundleLineItemType.NON_PRESCRIPTION_BUNDLE,
        bundleLineItems: [
            mainBundleLineItem,
            ...bundleLineItems.map((item)=>swcHelpers.objectSpread({}, item, {
                    quantity: (_quantity = item.quantity) !== null && _quantity !== void 0 ? _quantity : 1,
                    isMainBundleLineItem: false
                })
            ), 
        ]
    };
};

export { mapNonPrescriptionBundleLineItem };
//# sourceMappingURL=non-prescription-bundle.js.map
